export default __webpack_public_path__ + "static/media/fashion.b357e711.svg";